import axios from "axios";
import { API_URL } from "../config/AppConfig";

const chatApi = axios.create({
  baseURL: API_URL,
  timeout: 12000,
});

chatApi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token") 
               || localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const normalizeThreadResponse = (data = {}) => {
  if (!data) return {};
  const thread =
    data.thread ||
    data.data ||
    data.result ||
    data;

  if (Array.isArray(thread)) {
    return thread[0] || {};
  }

  return thread;
};

export const ensureChatThread = async ({ productId, buyerId, sellerId, meta }) => {
  const payload = {
    productId,
    buyerId,
    sellerId,
  };

  if (meta) {
    payload.meta = meta;
  }

  const { data } = await chatApi.post("/chats", payload);
  return normalizeThreadResponse(data);
};

export const fetchSellerThreads = async (sellerId) => {
  if (!sellerId) throw new Error("sellerId is required");
  const { data } = await chatApi.get(`/chats/seller/${sellerId}`);
  return data?.threads || data?.data || data || [];
};

export const fetchBuyerThreads = async (buyerId) => {
  if (!buyerId) throw new Error("buyerId is required");
  const { data } = await chatApi.get(`/chats/buyer/${buyerId}`);
  return data?.threads || data?.data || data || [];
};

export const fetchRoomMessages = async (roomId, params = {}) => {
  if (!roomId) throw new Error("roomId is required");
  const { data } = await chatApi.get(`/chats/${roomId}/messages`, {
    params,
  });
  return data?.messages || data?.data || data || [];
};

export const sendRoomMessage = async (roomId, payload) => {
  if (!roomId) throw new Error("roomId is required");
  const { data } = await chatApi.post(`/chats/${roomId}/messages`, payload);
  return data?.message || data?.data || data || {};
};

export const editMessage = async (roomId, messageId, payload) => {
  if (!roomId || !messageId) throw new Error("roomId and messageId are required");
  const { data } = await chatApi.patch(`/chats/${roomId}/messages/${messageId}/edit`, payload);
  return data?.message || data?.data || data || {};
};

export const unsendMessage = async (roomId, messageId) => {
  if (!roomId || !messageId) throw new Error("roomId and messageId are required");
  const { data } = await chatApi.patch(`/chats/${roomId}/messages/${messageId}/unsend`);
  return data?.message || data?.data || data || {};
};

export const deleteMessageForMe = async (roomId, messageId) => {
  if (!roomId || !messageId) throw new Error("roomId and messageId are required");
  const { data } = await chatApi.patch(`/chats/${roomId}/messages/${messageId}/delete`);
  return data?.message || data?.data || data || {};
};

export const deleteAllMessagesForMe = async (roomId) => {
  if (!roomId) throw new Error("roomId is required");
  const { data } = await chatApi.patch(`/chats/${roomId}/delete-all`);
  return data || {};
};

export default {
  ensureChatThread,
  fetchSellerThreads,
  fetchBuyerThreads,
  fetchRoomMessages,
  sendRoomMessage,
  editMessage,
  unsendMessage,
  deleteMessageForMe,
  deleteAllMessagesForMe,
};

